import _Tabs from './Tabs';

import './style/index.js';

export type { TabsProps } from './Tabs';
export type { TabPanelProps } from './TabPanel';
export * from './type';

export const Tabs = _Tabs;
export default Tabs;
